import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';

export class CMRFDTO {
@ApiProperty()
@ApiPropertyOptional()
Id: number;
@ApiProperty()
applicationNo:string;
@ApiProperty()
namePrefix: string;
@ApiProperty()
applicantName:string;
@ApiProperty()
applicantGender:string;
@ApiProperty()
prefixRelation:string;
@ApiProperty()
fatherOrHusbandName:string;
@ApiProperty()
nomineeRelation:string;
@ApiProperty()
nomineeAge:number;
@ApiProperty()
village:string;
@ApiProperty()
mandal:string;
@ApiProperty()
district:string;
@ApiProperty()
applicationReceivedDate:Date;
@ApiProperty()
mobileNo:string;
@ApiProperty()
aadharNo: string;
@ApiProperty()
nomineeAadharNo: string;
@ApiProperty()
age: number;
@ApiProperty()
houseNo: string;
@ApiProperty()
pinNo: string;
@ApiProperty()
RationOrIncomeNo: string;
@ApiProperty()
hospitalName:string;
@ApiProperty()
hospitalNo: string;
@ApiProperty()
disease: string;
@ApiProperty()
@ApiPropertyOptional()
dod: Date;
@ApiProperty()
finalBillAmount:string;
@ApiProperty()
finalBillAmountInWords:string;
@ApiProperty()
@ApiPropertyOptional()
fileSentDate: Date;
@ApiProperty()
@ApiPropertyOptional()
printDate: Date;
@ApiProperty()
@ApiPropertyOptional()
reference:string;
@ApiProperty()
@ApiPropertyOptional()
remarks:string;
@ApiProperty()
chequeReceivedOrNot:boolean;
@ApiProperty()
@ApiPropertyOptional()
chequeNo:string;
@ApiProperty()
@ApiPropertyOptional()
date:Date;
@ApiProperty()
@ApiPropertyOptional()
receivedAmountFromCMOffice: string;
@ApiProperty()
@ApiPropertyOptional()
chequeDistrubtionDate:Date;
@ApiProperty()
@ApiPropertyOptional()
status: boolean;
createdAt : Date;
@ApiProperty()
@ApiPropertyOptional()
@IsOptional()
createdUser : number;
updatedAt : Date;
@ApiProperty()
@ApiPropertyOptional()
@IsOptional()
updatedUser : number;
@ApiProperty()
@ApiPropertyOptional()
versionFlag : number;
}


export class DeleteDTO {
  @ApiProperty()
  Id: number;
  @ApiProperty()
  status: boolean;
  updatedAt : Date;
  @ApiProperty()
  updatedUser : number;
}



 




